var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-data-table',{attrs:{"headers":_vm.header,"items":_vm.Items.itens_sales}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }